import React from "react";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="w-full pt-[25rem] md:pt-0 md:w-1/2 h-[50svh] lg:h-[70svh] xl:h-[80svh] flex flex-col justify-center pb-[12%]"
    >
      <h1 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-semibold mb-2 md:mb-5">
        Portal Resmi
      </h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl xl:text-4xl font-semibold leading-normal mb-3 text-primary-800">
        Sistem Informasi Manajemen Sekwan DPRD Kab PALI
      </h2>
      <p className="leading-normal">
        SIMSEKWAN DPRD PALI adalah platform digital untuk tata kelola
        administarsi dan korespondensi, mencakup proses penerimaan, penyusunan
        hingga pengesahan, distribusi ke pihak terkait, pemantauan, sampai
        pengarsipan secara mudah dan transparan.
      </p>
    </section>
  );
}
